import { z } from "zod";
import type { SkillName } from "@/lib/core/schemas/skill-check.schema";

declare module "@/lib/core/schemas/skill-check.schema" {
  // biome-ignore lint/nursery/useConsistentTypeDefinitions: declaration-merge target requires interface
  interface SkillNameRegistry<_R extends string = "dnd5e"> {
    acrobatics: true;
    "animal-handling": true;
    arcana: true;
    athletics: true;
    deception: true;
    history: true;
    insight: true;
    intimidation: true;
    investigation: true;
    medicine: true;
    nature: true;
    perception: true;
    performance: true;
    persuasion: true;
    religion: true;
    "sleight-of-hand": true;
    stealth: true;
    survival: true;
  }
}

/** The dnd5e skill vocabulary (18 PHB skills), resolved from the core registry. */
export type Dnd5eSkillName = SkillName<"dnd5e">;

/** Runtime validation surface — a dnd5e concern, NOT a core one. Hand-authored;
 *  kept in lockstep with the registry augmentation by the parity guard below.
 *  The forgeSkillCheckSchema enum in core is kept identical to this (spec §5.2). */
export const Dnd5eSkillNameSchema = z.enum([
  "acrobatics",
  "animal-handling",
  "arcana",
  "athletics",
  "deception",
  "history",
  "insight",
  "intimidation",
  "investigation",
  "medicine",
  "nature",
  "perception",
  "performance",
  "persuasion",
  "religion",
  "sleight-of-hand",
  "stealth",
  "survival",
] as const);

/** Ordered runtime list. */
export const DND5E_SKILL_NAMES: readonly Dnd5eSkillName[] =
  Dnd5eSkillNameSchema.options;

type AssertEqual<A, B> = [A] extends [B]
  ? [B] extends [A]
    ? true
    : never
  : never;
export const _skillNameParity: AssertEqual<
  (typeof Dnd5eSkillNameSchema.options)[number],
  Dnd5eSkillName
> = true;
